import React from 'react';
import './Logo.sass'

function Logo() {
    return (
        <div className={'logo'}>
            <div className="logo__name">EUREYuri.</div>
            <div className="logo__subtitle">ui / ux designer</div>
        </div>
    );
}

export default Logo;